module.exports = __webpack_public_path__ + "8a834944ab510d9101a99676671ba351.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/bloomberg_2022_chart.png
// module id = 1639
// module chunks = 0